<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/bannerProvUbicacion.jpg')"
      :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
      aspect-ratio="3.65"
      contain
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="itemsBreadCrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-col cols="12" class="py-0">
      <v-row align="center" justify="center">
        <v-card
          class="ma-3 pa-6"
          style="border: 0px solid white"
          width="700"
          outlined
          tile
        >
          <p
            class="fontTitulo text-justify text-center mb-0"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'subfontTituloResponsive',
            ]"
          >
            Amplia red de proveedores estrátegicamente ubicados en las
            principales ciudades y carreteras de tráfico internacional que se
            traduce en tiempos de respuesta cortas.
          </p>
        </v-card>
      </v-row>
    </v-col>

    <v-container>
      <v-row class="d-flex justify-md-space-around">
        <v-col cols="12" md="4">
          <div
            id="mapContainer"
            class="mx-auto"
            style="max-width:700px; height: 500px"
          ></div>
        </v-col>

        <v-col cols="12" md="4" class="my-auto">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN SALVADOR</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(1)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>APOPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(2)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN MARCOS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(3)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN JACINTO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(4)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SOYAPANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon> 
                  <v-btn small color="blue" outlined @click="Flyto(5)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN VICENTE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(6)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>COJUTEPEQUE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(7)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>AGULARES</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(8)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4" class="my-auto">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHALATENANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(9)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>TEJUTLA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(10)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>LOURDES</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(11)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SANTA TECLA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(12)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CIUDAD MERLIOT</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(13)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SANTA ANA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(14)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SONSONATE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(15)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>AHUACHAPAN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(16)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>USULUTAN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(17)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN MIGUEL</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(20)" v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import mapboxgl from "mapbox-gl";

export default {
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    markers: [
      {
        id: 1,
        name: "SAN SALVADOR",
        position: [-89.219372, 13.693142],
      },
      {
        id: 2,
        name: "APOPA",
        position: [-89.180176, 13.80275],
      },
      {
        id: 3,
        name: "SAN MARCOS",
        position: [-89.182718, 13.65717],
      },
      {
        id: 4,
        name: "SAN JACINTO",
        position: [-89.188613, 13.686066],
      },
      {
        id: 5,
        name: "SOYAPANGO",
        position: [-89.139432, 13.709778],
      },
      {
        id: 6,
        name: "SAN VICENTE",
        position: [-88.78508, 13.643423],
      },
      {
        id: 7,
        name: "COJUTEPEQUE",
        position: [-88.936613, 13.721517],
      },
      {
        id: 8,
        name: "AGUILARES",
        position: [-89.185877, 13.964166],
      },
      {
        id: 9,
        name: "CHALATENANGO",
        position: [-88.918727, 14.017509],
      },
      {
        id: 10,
        name: "TEJUTLA",
        position: [-89.101889, 14.170625],
      },
      {
        id: 11,
        name: "LOURDES",
        position: [-89.369685, 13.723686],
      },
      {
        id: 12,
        name: "SANTA TECLA",
        position: [-89.288249, 13.675169],
      },
      {
        id: 13,
        name: "CIUDAD MERLIOT",
        position: [-89.268422, 13.678565],
      },
      {
        id: 14,
        name: "SANTA ANA",
        position: [-89.568315, 13.978046],
      },
      {
        id: 15,
        name: "SONSONATE",
        position: [-89.726822, 13.720142],
      },
      {
        id: 16,
        name: "AHUACHAPA",
        position: [-89.848123, 13.918986],
      },
      {
        id: 17,
        name: "USULUTAN",
        position: [-88.459211, 13.344150],
      },
      {
        id: 18,
        name: "USULUTAN",
        position: [-88.384398, 13.513477],
      },
      {
        id: 19,
        name: "SAN MIGUEL",
        position: [-88.182674, 13.480296],
      },
      {
        id: 20,
        name: "SAN MIGUEL",
        position: [-88.170465, 13.496363],
      },
      {
        id: 21,
        name: "SAN MIGUEL",
        position: [-88.158994, 13.459927],
      },
    ],
    itemsBreadCrumbs: [
      {
        text: "HOME",
        disabled: false,
        href: "/",
      },
      {
        text: "NUESTROS PROVEEDORES EL SALVADOR",
        disabled: true,
        href: "",
      },
    ],
    map: "",
    accessToken:
      "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
  }),

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-88.89653, 13.794185],
      zoom: 7,
    });
    for (var i = 0; i < this.markers.length; i++) {
      var marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat(this.markers[i].position)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" + this.markers[i].name + "</strong>"
          )
        )
        .addTo(this.map);
    }
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
  },

  methods: {
    Flyto(i) {
      switch(i){
        case 1:
          var center = this.markers[i-1].position;
          break;
        case 2:
          var center = this.markers[i-1].position;
          break;
        case 3:
          var center = this.markers[i-1].position;
          break;
        case 4:
          var center = this.markers[i-1].position;
          break;
        case 5:
          var center = this.markers[i-1].position;
          break;
        case 6:
          var center = this.markers[i-1].position;
          break;
        case 7:
          var center = this.markers[i-1].position;
          break;
        case 8:
          var center = this.markers[i-1].position;
          break;
        case 9:
          var center = this.markers[i-1].position;
          break;
        case 10:
          var center = this.markers[i-1].position;
          break;
        case 11:
          var center = this.markers[i-1].position;
          break;
        case 12:
          var center = this.markers[i-1].position;
          break;
        case 13:
          var center = this.markers[i-1].position;
          break;
        case 14:
          var center = this.markers[i-1].position;
          break;
        case 15:
          var center = this.markers[i-1].position;
          break;
        case 16:
          var center = this.markers[i-1].position;
          break;
      }
      this.map.flyTo({
        center: center,
        zoom: 13,
        bearing: 0,
        speed: 0.5,
        curve: 1,
        easing: function(t) {
          return t;
        },
        essential: true,
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.fontTitulo {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
.fontTituloResponsive {
  font-family: "EB Garamond", serif;
  font-size: 15px;
}
</style>
